<template>
  <v-container fill-height fluid class="app-pagar">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="5" xl="4">
        <v-card elevation="2" class="mx-auto" max-width="470" :disabled="loading">
          <v-progress-linear height="4" v-show="loading" indeterminate color="#FF5414"></v-progress-linear>
          <v-card-title>
            <v-img
              :src="require('../../assets/img/Logo-Empresas-830x354.png')"
              max-width="180"
              max-height="180"
              alt="Gugla Empresas"
              style="display: block; margin-left: auto; margin-right: auto"
            />
          </v-card-title>
          <v-card-text class="text-center">
            <h2 style="color: #FF5414; margin-bottom: 8px">Subscrever o Gugla</h2>
            <p style="margin-bottom: 24px">
              Entre com a mesma conta que usa na app Gugla para escolher o plano e pagar.
            </p>

            <v-btn block large depressed rounded dark color="#000" class="apple-btn" @click="loginApple">
              <v-icon left>mdi-apple</v-icon>
              Continuar com a Apple
            </v-btn>

            <p v-if="notSafariOnIos" class="hint">
              Para entrar com a Apple mais rapidamente, abra esta página no Safari.
            </p>

            <div class="divider"><span>ou</span></div>

            <v-btn block large depressed rounded outlined color="#FF4500" @click="loginEmail">
              Entrar com e-mail ou telemóvel
            </v-btn>

            <p v-if="error" class="error-text">{{ error }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { url } from "../../services/server";
import { markFromApp } from "../../services/appReturn";
import { signInWithApple, isAppleCancel } from "../../services/appleSignIn";

// Planos de subscrição de concursos (o mesmo destino dos links do site).
const PLANS_ROUTE = { name: "site.subscricao", params: { tipo_subscricao: 1 } };

/**
 * Entrada vinda da app iOS (link do assistente de apoio no WhatsApp):
 * autentica (Apple ou e-mail/telemóvel) e leva aos planos e pagamentos.
 * A visita fica marcada (appReturn) para o sucesso do pagamento lembrar de
 * voltar à app.
 */
export default {
  data() {
    return {
      loading: false,
      error: null,
    };
  },
  computed: {
    // Chrome/Firefox/Edge no iPhone não mostram a folha nativa da Apple.
    notSafariOnIos() {
      const ua = navigator.userAgent || "";
      return /iPhone|iPad|iPod/.test(ua) && /CriOS|FxiOS|EdgiOS/.test(ua);
    },
  },
  created() {
    markFromApp();
    if (localStorage.getItem("TOKEN_AUTH")) {
      this.goToPlans();
    }
  },
  methods: {
    loginApple() {
      this.error = null;
      signInWithApple()
        .then((apple) => {
          this.loading = true;
          return axios.post(`${url}/api/recruiters/recruiter/login-apple`, {
            identity_token: apple.idToken,
            email: apple.email,
            name: apple.name,
          });
        })
        .then((res) =>
          this.$store.dispatch("loginWithWhatsappOtp", {
            token: res.data.token,
            recruiter: res.data.recruiter,
          })
        )
        .then(() => {
          this.$store.dispatch("changeLoginDialog", false);
          this.goToPlans();
        })
        .catch((err) => {
          this.loading = false;
          if (isAppleCancel(err)) return;
          this.error = "Não foi possível entrar com a Apple. Tente novamente.";
        });
    },
    // A página de planos (/subscricao/1) atualiza o registo de visita criado
    // pela página anterior do fluxo normal (/planos-disponiveis →
    // localStorage "id_subs"). Como aqui se entra direto nos planos, cria-se
    // esse registo primeiro — sem ele, o pedido vai com id null e o backend
    // responde 500 ("Erro interno do servidor").
    goToPlans() {
      this.loading = true;
      this.$store
        .dispatch("subscribePageLogs", {
          recruiter_email: localStorage.getItem("RECRUITER_EMAIL"),
          subscribe_page_select: 1,
        })
        .then((res) => localStorage.setItem("id_subs", res.data.id))
        .catch(() => {})
        .then(() => this.$router.replace(PLANS_ROUTE));
    },
    loginEmail() {
      // Depois do login normal, o site volta a esta página (sessionStorage
      // "url" — o mesmo mecanismo das restantes páginas), que segue para os
      // planos pelo mesmo caminho do login com a Apple.
      sessionStorage.setItem("url", window.location.href);
      this.$router.push({ name: "candidate.login" });
    },
  },
};
</script>

<style scoped>
.app-pagar {
  min-height: 100vh;
  background-color: #f0f2f5;
}
.apple-btn {
  text-transform: none;
  font-weight: 600;
}
.hint {
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0;
}
.divider {
  display: flex;
  align-items: center;
  margin: 18px 0;
  color: #999;
}
.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ddd;
}
.divider span {
  padding: 0 10px;
}
.error-text {
  color: #ff1744;
  margin-top: 16px;
  margin-bottom: 0;
}
</style>
